// MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS:
//   ROOT: app/assets/javascripts/libraries_and_infrequently_changed.js
// MAGIC_DESPROCKET_END
if (typeof window !== 'undefined') {
  var $a = window.$a || {};

  window.$a = {
    ...$a,
    loginUrlWithRedirect: function(redirectUrl) {
      redirectUrl = redirectUrl || window.location.href;
      return $r.login_url({
        post_login_redirect_url: encodeURIComponent(redirectUrl),
      });
    },

    // Return an array with the separator interspersed between each
    // element of the input array.
    //
    // > $a.intersperse(["a", "b", "c"], " - ")
    // ["a", " - ", "b", " - ", "c"]
    intersperse: function(array, separator) {
      if (array.length === 0) { return []; }

      return array.slice(1).reduce(function(xs, x) {
        return xs.concat([separator, x]);
      }, [array[0]]);
    },

    // Return an object with `null` and `undefined` values removed.
    compact: function(oldObject) {
      return Object.keys(oldObject).reduce(function(newObject, key) {
        var value = oldObject[key];
        if (value !== null && value !== undefined) {
          newObject[key] = value;
        }
        return newObject;
      }, {});
    },

    isTinyScreen: function() {
      return window.matchMedia("(max-width: 545px)").matches;
    },

    isSmallScreen: function() {
      return window.matchMedia("(max-width: 767px)").matches;
    },

    isLargeScreen: function() {
      return window.matchMedia("(min-width: 1024px)").matches;
    },

    preloadImage: function(url) {
      (new Image()).src = url;
    },

    devAlertAdminConsole: function() {
      if ($rails_env === 'development' && window) {
        window.alert(Array.prototype.slice.call(arguments));
      } else {
        $a.admin_log.apply(this, arguments);
      }
    },
  };
}

export const loginUrlWithRedirect = $a.loginUrlWithRedirect;
